import React from "react";
import { Box, Typography } from "@mui/material";
import ExoExplorer from "../exo/ExoExplorer";
import FieldInfo from "../form/FieldInfo";

export const StepFiles = ({
  dataCollection,
  updateValidation,
  updateDataCollection,
  dataKey,
  type,
  filter,
  heading,
  info,
}) => {
  function handleChange(e) {
    updateDataCollection({ [dataKey]: e });
  }
  return (
    <Box className="flex h-full w-full flex-col gap-2 overflow-hidden">
      {heading && (
        <Box className="flex items-center gap-1">
          <Typography variant="h6">{heading}</Typography>
          <FieldInfo info={info} />
        </Box>
      )}
      <Box className="min-h-0 flex-1">
        <ExoExplorer
          preSelected={dataCollection[dataKey] || []}
          multiSelect
          maxItems={20}
          maxSizeKB={100000}
          noControls
          onSelectionChange={handleChange}
          mediaType={type}
          noTypeChange
          filter={filter}
        />
      </Box>
    </Box>
  );
};
